var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcNavAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.29004C7.87391 2.29004 6.15065 4.0133 6.15065 6.13939C6.15065 8.26548 7.87391 9.98874 10 9.98874C12.1261 9.98874 13.8493 8.26548 13.8493 6.13939C13.8493 4.0133 12.1261 2.29004 10 2.29004ZM4.90065 6.13939C4.90065 3.32293 7.18354 1.04004 10 1.04004C12.8165 1.04004 15.0993 3.32293 15.0993 6.13939C15.0993 8.95585 12.8165 11.2387 10 11.2387C7.18354 11.2387 4.90065 8.95585 4.90065 6.13939Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.4551C6.35482 12.4551 3.33398 14.7355 3.33398 17.6217C3.33398 17.9669 3.61381 18.2467 3.95898 18.2467C4.30416 18.2467 4.58398 17.9669 4.58398 17.6217C4.58398 15.6427 6.87069 13.7051 10 13.7051C13.1293 13.7051 15.416 15.6427 15.416 17.6217C15.416 17.9669 15.6958 18.2467 16.041 18.2467C16.3862 18.2467 16.666 17.9669 16.666 17.6217C16.666 14.7355 13.6452 12.4551 10 12.4551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcNavAvatarIcon);
export default __webpack_public_path__ + "static/media/tc_nav_avatar_icon.4791a0b968fa44015e5705191a998528.svg";
export { ForwardRef as ReactComponent };